import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* handleAPIError() {
  yield takeEvery(actionTypes.HANDLE_API_ERROR, function* (action) {
    let error = action.error;

    if (error.response && error.response.status) {
      if (error.response.status !== 401) {
        alert(
          "Error: " +
            (action.message !== "" ? action.message + "\n" : "") +
            API.constructErrMsg(action.error)
        );
      }
    } else {
      //   console.log("Handle api error:", error);
    }
    yield put(actions.disableLoading());
  });
}

export function* getPhoneNumbers() {
  yield takeEvery(actionTypes.GET_PHONE_NO, function* (action) {
    try {
      const response = yield API.getWhatsApp();
      const response_two = yield API.getPhoneNumber();
      yield put(
        actions.getPhoneNoSuccess({
          whatsapp_no: response.data.success ? response.data.data : "",
          hotline_no: response_two.data.success ? response_two.data.data : "",
        })
      );
    } catch (error) {}
  });
}

export default function* appSaga() {
  yield all([fork(handleAPIError), fork(getPhoneNumbers)]);
}
